import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CountriesModule } from '@nibtravel/shared/data-access/countries';
import { GtmAnalyticsModule } from '@nibtravel/shared/data-access/gtm-analytics';
import { QuoteStateModule } from '@nibtravel/shared/data-access/quote';
import { UiContextModule } from '@nibtravel/shared/data-access/ui-context';
import { AgeAmbiguityModule } from '@nibtravel/shared/features/age-ambiguity';
import { DomesticInternationalAlertModule } from '@nibtravel/shared/features/domestic-international-alert';
import { PmiOptionModule } from '@nibtravel/shared/features/pmi';
import { QqcDestinationModule } from '@nibtravel/qqc/features/destination';
import { QqcTravelDatesModule } from '@nibtravel/qqc/features/travel-dates';
import { QqcAgeInputModule } from '@nibtravel/qqc/features/age-input';
import { QqcTripSelectorModule } from '@nibtravel/qqc/features/trip-selector';
import { QqcAlertModule } from '@nibtravel/qqc/features/alert';
import { ButtonModule } from '@nibtravel/shared/ui/components/button';
import { IconModule } from '@nibtravel/shared/ui/components/icon';
import { LinkIconModule } from '@nibtravel/shared/ui/components/link-icon';
import { ModalModule } from '@nibtravel/shared/ui/components/modal';
import { SidebarModule } from '@nibtravel/shared/ui/components/sidebar';
import { FocusModule } from '@nibtravel/shared/ui/directives/focus';
import { CheckboxModule } from '@nibtravel/shared/ui/forms/checkbox';
import { DropdownModule } from '@nibtravel/shared/ui/forms/dropdown';
import { RadioGroupModule } from '@nibtravel/shared/ui/forms/radio-group';
import { ValidationModule } from '@nibtravel/shared/ui/forms/validation';
import { AppConfigModule } from '@nibtravel/shared/util/app-config';
import { FeatureToggleModule } from '@nibtravel/shared/util/feature-toggle';
import { GtmModule } from '@nibtravel/shared/util/gtm';
import { ModelsModule } from '@nibtravel/shared/util/models';
import { ServiceModule } from '@nibtravel/shared/util/service';
import { QqcComponent } from './qqc.component';
import { IconsModule } from '@nibtravel/shared/ui/icons';
import { i18nModule } from '@nibtravel/shared/util/i18n';

@NgModule({
  imports: [
    CommonModule,
    CountriesModule,
    FeatureToggleModule,
    QqcTravelDatesModule,
    QqcAgeInputModule,
    QqcDestinationModule,
    QqcTripSelectorModule,
    QqcAlertModule,
    UiContextModule,
    ReactiveFormsModule,
    AppConfigModule,
    QuoteStateModule,
    ModelsModule,
    ButtonModule,
    RadioGroupModule,
    DropdownModule,
    CheckboxModule,
    ServiceModule,
    ModalModule,
    AgeAmbiguityModule,
    DomesticInternationalAlertModule,
    IconModule,
    IconsModule,
    ValidationModule,
    LinkIconModule,
    PmiOptionModule,
    SidebarModule,
    FocusModule,
    GtmModule,
    GtmAnalyticsModule,
    i18nModule.forChild({
      scope: 'qqc',
      alias: 'qqc',
    }),
  ],
  declarations: [QqcComponent],
  exports: [QqcComponent],
})
export class QqcModule {}
